<template>
  <generic-list :apiUrls="apiUrls" :formCols="formCols" :updateCols="updateCols" :tableCols="tableCols"></generic-list>
</template>

<script>
import genericList from '@/views/commonPage/genericList.vue'
import URL from '@/views/business/util/url'
let isDelete = { "1": "启用", "2": "禁用" };
let pushType = { "1": "发送验证码", "2": "重置密码" };
export default {
  name: "messageTemplate",
  components: {
    genericList
  },
  data() {
    return {
      apiUrls: {
        query: URL.smsMessageTemplate.query,
        addOrUpdate: URL.smsMessageTemplate.addOrUpdate,
        deleteBatchIds: URL.smsMessageTemplate.deleteBatchIds,
        status: URL.smsMessageTemplate.status
      },
      formCols: [
        { title: '业务编码', field: 'code' },
        { title: '短信分类', field: 'pushType', type: 2, optionList: pushType },
        { title: '状态', field: 'isDelete', type: 2, optionList: isDelete },
        {
          title: '创建时间',
          field: 'time3',
          type: 6,
          format: 'yyyy-MM-dd HH:mm:ss',
          startEndParam: ['createDateBegin', 'createDateEnd']
        },
        { click: window.$t('business.bt.search') },
        { click: window.$t('business.bt.add'), auth: 'business:smsMessageTemplate:save' }
      ],
      updateCols: [
        { title: 'id', field: 'id', hidden: true },
        { title: '模板编码', field: 'code' },
        { title: '短信分类', field: 'pushType', type: 2, optionList: pushType, required: true, isNumber: true },
        { title: '短信标题', field: 'title', maxlength: 50 },
        { title: '短信描述', field: 'remark', maxlength: 50 },
        { title: '短信有效期(默认60秒有效期)', field: 'second' },
        { title: '手机当天次数限制', field: 'mobileLimitTime' },
        { title: 'IP当内验证码限制', field: 'ipLimitTime' },
        { title: '短信内容(占位符必须以:{{param}})', field: 'content', type: 6, uploadUrl: URL.detailTask.uploadUrl },
        { title: '状态', field: 'isDelete', type: 2, optionList: isDelete, isNumber: true },
      ],
      tableCols: [
        { title: '业务编码', field: 'code' },
        { title: '语言', field: 'templateLanguage' },
        {
          title: '短信分类', field: 'pushType', render: (data, full) => {
            return pushType[data];
          }
        },
        {
          title: '短信模板', minWidth: 200, field: 'content', dangerouslyUseHTMLString: true,
          render: (data) => {
            return data ? data.replace(/(.{20})/g, '$1<br>') : '';
          }
        },
        // { title: '短信有效期(默认60秒有效期)', field: 'second' },
        // { title: '手机当天次数限制', field: 'mobileLimitTime' },
        { title: '短信描述', field: 'remark' },
        { title: '创建时间', field: 'createDate' },
        { title: '创建人', field: 'createUser' },
        { title: '修改人', field: 'updateUser' },
        { title: '修改时间', field: 'updateDate' },
        {
          field: "isDelete",
          notice: function (value, row) {
            return (value === '1' || value === 1) ? '启用' : '禁用';
          },
          title: "显示/隐藏开关", size: "mini", click: "status", stype: '100', activeText: "启用", inactiveText: "禁用", hidden: "true", auth: 'business:smsMessageTemplate:status'
        },
        {
          title: window.$t("business.bt.operation"), minWidth: "180",
          btnClick: [
            { name: window.$t("business.bt.edit"), click: "update", type: "primary", size: "mini", icon: "el-icon-edit", auth: 'business:smsMessageTemplate:edit' },
            { name: window.$t("business.bt.delete"), click: "delete", type: "primary", size: "mini", icon: "el-icon-delete", auth: 'business:smsMessageTemplate:delete' }
          ]
        },
      ]
    };
  }
}
</script>